import React, {Component} from 'react';
import {
    Dialog,
    DialogContent,
    Icon,
    Button,
    IconButton,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {UecareDropdown, UecareInput, UecareDate} from '../../../../components';
import {constDataDialogs} from '../../../../constants';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxGroup from '../../../../store/actionreducers/group';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
});

const initNewGroupState = {
    name: '',
    no: '',
    max_vip_amount: 4,
    current_point: 0,
    join_date: null,
    expire_date: null,
    company: null,
    main_vip: null,
    type: {
        name: '個人會員',
        label: 'person',
    }
};

const initControllerState = {
    groupType: {label: 'person'},
};

class GroupDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {group: initNewGroupState, ...initControllerState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.groupDialog) {

            /**
             * After Dialog Open
             */
            if (!prevProps.groupDialog || (!prevProps.groupDialog.props.open && this.props.groupDialog.props.open)) {
                /**
                 * Dialog type: 'edit'
                 * Update State
                 */
                if (this.props.groupDialog.type === 'edit' &&
                    this.props.group &&
                    !_.isEqual(this.props.group, prevState.group)) {
                    this.setState({
                        group: this.props.group,
                        groupType: this.props.group.type,
                        company: this.props.group.company
                    });
                }

                /**
                 * Dialog type: 'new'
                 * Update State
                 */
                if (this.props.groupDialog.type === 'new') {
                    this.setState({group: initNewGroupState, groupType: this.props.personGroupType});
                }
            }
        }
    }

    _isGroupEdit() {
        if (this.props.group.id !== this.state.group.id) return true;
        if (this.props.group.company && this.props.group.company.id !== this.state.company.id) return true;
        if (this.props.group.type.label !== this.state.groupType.label) return true;
        return false;
    };

    _getGroupTypeId = () => {
        if (this.state.groupType && this.state.groupType.id) return this.state.groupType.id;
        if (this.state.group.type && this.state.group.type.id) {
            const groupType = this.props.groupTypes.find((groupType) => {
                return groupType.id === this.state.group.type.id;
            });
            if (groupType) return groupType.id; // 確認取到的 groupType 有沒有在 groupType list 中
        }

        if (this.props.personGroupType && this.props.personGroupType.id) return this.props.personGroupType.id;
        return 0;
    };

    _getDialogAction() {

        const {addGroup, updateGroup, groupDialog} = this.props;

        const addButton = (
            <Button
                variant="raised"
                color="primary"
                disabled={!this.canBeSubmitted()}
                onClick={async () => {
                    try {
                        await addGroup({
                            ...this.state.group,
                            company: this.state.company,
                            type: this.state.groupType
                        });
                        this.closeDataDialog();
                    } catch (e) {
                        console.warn('you got an error = ', e);
                    }
                }}
            >
                新增
            </Button>
        );

        const updateButton = (
            <Button
                variant="raised"
                color="primary"
                disabled={!this.canBeSubmitted()}
                onClick={async () => {
                    try {
                        await updateGroup({
                            ...this.state.group,
                            company: this.state.company,
                            type: this.state.groupType
                        });
                        this.closeDataDialog();
                    } catch (e) {
                        console.warn('you got an error = ', e);
                    }
                }}
            >
                修改
            </Button>
        );

        const deleteButton = (
            <IconButton
                onClick={() => {
                    // delete group ?
                    this.closeDataDialog();
                }}
            >
                <Icon>delete</Icon>
            </IconButton>
        );

        if (groupDialog.type === 'new') {
            return (
                <DialogActions className="justify-between pl-16">
                    {addButton}
                </DialogActions>
            );
        } else {
            return (
                <DialogActions className="justify-between pl-16">
                    {updateButton}
                    {((this.state.group.vips || []).length > 0) ? '' : deleteButton}
                </DialogActions>
            );
        }

    }

    handleDropDownChange = (name, value) => {
        this.setState({[name]: value});
    };

    handleChange = (event) => {
        const newGroup = {...this.state.group, [event.target.name]: event.target.value};
        this.setState({group: newGroup});
    };

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.groupDialog});
    };

    canBeSubmitted() {
        if (this.state.groupType.label === 'company') {
            return this.state.company && this.state.group.name && this.state.group.name.length > 0;
        } else {
            return this.state.group.name && this.state.group.name.length > 0;
        }
    }

    render() {
        const {classes, companies, groupDialog, groupTypes} = this.props;

        if (!groupDialog || groupDialog.props.open === false) return <div/>;

        return (
            <Dialog className={classes.root}
                    open={false}
                    {...groupDialog.props}
                    onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {groupDialog.type === 'new' ? '新的帳戶資料' : '帳戶資料'}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <UecareInput
                        label='群組帳戶名稱'
                        icon='account_circle'
                        name='name'
                        id='name'
                        className={classes.formControl}
                        value={this.state.group.name || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='帳戶最大會員數'
                        icon='star'
                        name='max_vip_amount'
                        id='max_vip_amount'
                        inputType='number'
                        disabled
                        className={classes.formControl}
                        value={this.state.group.max_vip_amount || ''}
                        onChange={this.handleChange}/>

                    {
                        groupDialog.type === 'new' ?
                            <div/>
                            :
                            <div>
                                <UecareInput
                                    label='群組帳戶編號'
                                    name='no'
                                    id='no'
                                    disabled
                                    className={classes.formControl}
                                    value={this.state.group.no || ''}
                                    onChange={this.handleChange}/>
                                <UecareDate
                                    icon="date_range"
                                    id="join_date"
                                    name="join_date"
                                    label="加入益友日期"
                                    disabled
                                    className={classes.formControl}
                                    value={moment(this.state.group.join_date).format('YYYY-MM-DD')}
                                    onChange={this.handleChange}
                                />

                                <UecareDate
                                    icon="date_range"
                                    id="expire_date"
                                    name="expire_date"
                                    label="到期日"
                                    disabled
                                    className={classes.formControl}
                                    value={moment(this.state.group.expire_date).format('YYYY-MM-DD')}
                                    onChange={this.handleChange}
                                />
                            </div>
                    }

                    <UecareDropdown
                        label='群組帳戶類型'
                        icon='star'
                        name='groupTypeId'
                        id='groupType'
                        disabled
                        className={classes.formControl}
                        value={this._getGroupTypeId()}
                        options={groupTypes}
                        onChange={(event, selectedOption) => {
                            this.handleDropDownChange('groupType', selectedOption);
                        }}/>

                    {
                        (this.state.groupType.label === 'company') ?
                            <UecareDropdown
                                label='企業'
                                icon='business'
                                name='companyId'
                                id='company'
                                disabled
                                className={classes.formControl}
                                value={
                                    (this.state.company && this.state.company.id) ||
                                    (this.state.group.company && this.state.group.company.id) || 0
                                }
                                options={companies}
                                onChange={(event, selectedOption) => {
                                    this.handleDropDownChange('company', selectedOption);
                                }}/>
                            :
                            <div/>
                    }
                </DialogContent>

                {this._getDialogAction()}

            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addGroup: ReduxGroup.ActionCreator.addGroup,
        updateGroup: ReduxGroup.ActionCreator.updateGroup,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
    }, dispatch);
}

function mapStateToProps({global: {dataDialogs}, group: { group, leftCanUse}, company: {companies}, vip: {vip}, groupType}) {

    const personGroupType = groupType.list.find((groupType) => {
        return groupType.label === 'person';
    });

    return {
        groupDialog: dataDialogs[constDataDialogs.name.groupDialog],
        group,
        companies,
        vip,
        groupTypes: groupType.list,
        leftCanUse,
        personGroupType
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(GroupDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/group/GroupDialog.js